import { reactive, ref } from 'vue';
import { defineStore } from 'pinia';
import { getUrlQuery } from '@common/utils/param';
import { baseMixins } from '@common/mixins/baseMixins';
import { getContractKeys } from '@common/core/network/NodeAPI';
const contractKeys = {
    // 品宣页-产品资料概要
    loanDetail: '',
    // 品宣页-条款及细则
    loanTerms: '',
    // 合同阅读页
    loanProduct: '',
    // 确认资料页
    loanComfirm: '',
    // 确认额度页
    loanLimitComfirm: '',
    // 提款页-条款及条件
    loanDraw: '',
    // 提款页-直接付款授权条款及细则
    entrustedpay: '',
};
export const useContractKeys = defineStore('useContractKeys', () => {
    const { getBaseParam } = baseMixins();
    const prodNo = getBaseParam('prodNo');
    const senceId = getUrlQuery('senceId');
    const contractKeysState = reactive(contractKeys);
    const ready = ref(false);
    const error = reactive({ code: '', message: '' });
    const refreshContractKeys = async () => {
        if (ready.value) {
            return;
        }
        const resp = await getContractKeys(prodNo, senceId);
        ready.value = true;
        Object.assign(contractKeysState, resp);
    };
    return {
        contractKeysState,
        refreshContractKeys,
        ready,
        error,
    };
}, {
    // @ts-ignore
    persist: true,
});
